// EditInsuranceSection.tsx
import React from 'react'
import {Input, LiveSearch, TitleText} from '../../../common'
import {IK_NUMBER_REGEX, INSURANCE_NUMBER_REGEX} from '../../../../utils/constants'
import {EditInsuranceKey} from '../utils/keys'
import {i18n} from '../../../../i18n'
import {SearchTypes} from '../../../../utils/enums'

type InsuranceFieldKey = (typeof EditInsuranceKey)[keyof typeof EditInsuranceKey]

interface EditInsuranceSectionProps {
    extractInsuranceProps: (fieldKey: InsuranceFieldKey) => any
}

const EditInsuranceSection: React.FC<EditInsuranceSectionProps> = ({extractInsuranceProps}) => {

const insuranceSearchDefaultValue = {ik: extractInsuranceProps(EditInsuranceKey.ik).value, name: extractInsuranceProps(EditInsuranceKey.name).value} 

    return (
        <div>
            <TitleText text={i18n.t('userDataTab.header.insurance')} />
            <LiveSearch
                label={i18n.t('userDataTab.insurance.name.title')}
                {...extractInsuranceProps(EditInsuranceKey.name)}
                searchType={SearchTypes.insurance}
                searchThreshold={1}
                allowCustomValues={true}
                defaultValue={insuranceSearchDefaultValue.ik ? insuranceSearchDefaultValue : undefined}
                onValueChanged={v => {
                    extractInsuranceProps(EditInsuranceKey.name).onValueChanged(v?.name)
                    extractInsuranceProps(EditInsuranceKey.ik).onValueChanged(v?.ik)
                }}
            />
            <Input
                label={i18n.t('userDataTab.insurance.IK.title')}
                {...extractInsuranceProps(EditInsuranceKey.ik)}
                regex={IK_NUMBER_REGEX}
                pixelAlignTop={true}
            />
            <Input
                label={i18n.t('userDataTab.insurance.number.title')}
                regex={INSURANCE_NUMBER_REGEX}
                {...extractInsuranceProps(EditInsuranceKey.number)}
                pixelAlignTop={true}
            />
        </div>
    )
}

export default EditInsuranceSection
